import { useAtom } from 'jotai'
import { alertAtom } from '@/store/atoms/atom'

export const useAlert = () => {
  const [alert, setAlert] = useAtom(alertAtom)

  return {
    alert,
    setAlert
  }
}
